// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-modal {
  width: 81rem;
}
.delete-modal p {
  width: 59rem;
}
.delete-modal h3 {
  margin-top: 0;
  padding-bottom: 0;
}
.delete-modal .buttons {
  margin-top: 4.8rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.delete-modal .buttons .button-component {
  width: auto;
}
.delete-modal .buttons :nth-child(1) button {
  width: 12.5rem;
  margin-right: 1.6rem;
}
.delete-modal .buttons :nth-child(2) button {
  width: 23rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Navigations/CreateWorkBottomNavs/DeleteDraftModal/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,aAAA;EACA,iBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ;AAGI;EACE,WAAA;AADN;AAII;EACE,cAAA;EACA,oBAAA;AAFN;AAKI;EACE,YAAA;AAHN","sourcesContent":[".delete-modal {\n  width: 81rem;\n\n  p {\n    width: 59rem;\n  }\n\n  h3 {\n    margin-top: 0;\n    padding-bottom: 0;\n  }\n\n  .buttons {\n    margin-top: 4.8rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n\n    .button-component {\n      width: auto;\n    }\n\n    :nth-child(1) button {\n      width: 12.5rem;\n      margin-right: 1.6rem;\n    }\n\n    :nth-child(2) button {\n      width: 23rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
